import { Injectable } from "@angular/core";
import { Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { NativeStorage } from '@ionic-native/native-storage';

@Injectable()
export class ProfileService {
  constructor(
    public http: Http,
    public nativeStorage: NativeStorage
  ) {}

  

}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.service.ts